import { StateCreator } from 'zustand';
import { allSlices, chatSlice } from './interface';

const createChatSlice: StateCreator<allSlices, [], [], chatSlice> = (set) => ({
  messages: [],
  notification: false,
  hasMore: true,
  addAllMessages: (messages) => {
    set((state) => ({
      chat: {
        ...state.chat,
        messages: [...messages, ...state.chat.messages]
      }
    }));
  },
  addMessage: (message) => {
    set((state) => ({
      chat: {
        ...state.chat,
        messages: [...state.chat.messages, message]
      }
    }));
  },
  setChatData: (data) => {
    set((state) => ({ chat: { ...state.chat, ...data } }));
  }
});

export default createChatSlice;
